var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgHeart = function SvgHeart(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    role: "img",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "m4.714 12.471 6.638 6.86c.27.278.405.418.57.444a.5.5 0 0 0 .156 0c.165-.026.3-.166.57-.445l6.638-6.859a4.71 4.71 0 0 0 .464-5.994c-1.94-2.75-6.167-2.206-7.347.946L12 8.5l-.403-1.077c-1.18-3.152-5.407-3.696-7.347-.946a4.71 4.71 0 0 0 .464 5.994Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHeart);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;